import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Output,
} from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MatChip } from '@angular/material/chips'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'
import { IsoDurationPipe } from '@elderbyte/ngx-starter'
import {
  IRouteSelectDialogSingleOptions,
  ScheduleSelectDialogSingleComponent,
} from '../schedule-select-dialog-single/schedule-select-dialog-single.component'
import { WorkItem, WorkItemSegment, WorkItemState } from '../work-item'

@Component({
  selector: 'app-item-production-route-detail',
  templateUrl: './item-production-route-detail.component.html',
  styleUrls: ['./item-production-route-detail.component.scss'],
  imports: [MatIconButton, MatIcon, MatTooltip, MatChip, IsoDurationPipe],
})
export class ItemProductionRouteDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  item = input.required<WorkItem>()

  readonly workItemStates = WorkItemState

  @Output()
  public readonly itemChangedId: EventEmitter<string> = new EventEmitter<string>()
  private dialog = inject(MatDialog)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public showMakespan(segment: WorkItemSegment): boolean {
    return segment.plannedMakeSpan !== 'PT2562047788015H12M55.807S' // Max Java Duration
  }

  public chooseProductionRoute(item: WorkItem): void {
    const dialogRef = this.dialog.open(ScheduleSelectDialogSingleComponent, {
      minWidth: '90vw',
      height: '90vh',
      data: <IRouteSelectDialogSingleOptions>{
        item: item,
      },
    })

    dialogRef.afterClosed().subscribe((id) => this.itemChangedId.emit(id))
  }
}
